var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("figure", { staticClass: "pigean-support-figure" }, [
    _vm.colorKey && _vm.points.length
      ? _c(
          "div",
          { staticClass: "pigean-color-legend" },
          [
            _c("span", [_vm._v(_vm._s(_vm.colorLabel))]),
            _vm.colorDomain
              ? [
                  _c("span", [_vm._v(_vm._s(_vm.format(_vm.colorDomain[0])))]),
                  _c("span", {
                    staticClass: "pigean-color-gradient",
                    style: { background: _vm.colorGradient },
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.format(_vm.colorDomain[1])))]),
                ]
              : _vm._e(),
            _vm.missingColors
              ? _c("span", { staticClass: "pigean-color-missing" }, [
                  _c("i", { attrs: { "aria-hidden": "true" } }),
                  _vm._v(" Unavailable "),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _c(
      "div",
      {
        ref: "host",
        staticClass: "pigean-support-plot",
        style: { height: _vm.height + "px" },
      },
      [
        _c("canvas", {
          ref: "canvas",
          attrs: {
            "aria-label": `${
              _vm.title
            }. ${_vm.points.length.toLocaleString()} points. Select an identifier in the table for keyboard access.`,
            role: "img",
          },
          on: {
            mousemove: _vm.hover,
            mouseleave: function ($event) {
              _vm.tip = null
            },
            click: _vm.selectPoint,
          },
        }),
        _c("svg", { ref: "axes", attrs: { "aria-hidden": "true" } }),
        _vm.tip
          ? _c(
              "div",
              {
                staticClass: "pigean-plot-tooltip",
                style: { left: _vm.tip.left + "px", top: _vm.tip.top + "px" },
              },
              [
                _c("strong", [_vm._v(_vm._s(_vm.tip.row.id))]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.xLabel) +
                      ": " +
                      _vm._s(_vm.format(_vm.tip.row[_vm.xKey]))
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.yLabel) +
                      ": " +
                      _vm._s(_vm.format(_vm.tip.row[_vm.yKey]))
                  ),
                ]),
                _vm.colorKey
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.colorLabel) +
                          ": " +
                          _vm._s(_vm.format(_vm.tip.row[_vm.colorKey])) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]
    ),
    _c("figcaption", [
      _vm._v(
        " " +
          _vm._s(_vm.points.length.toLocaleString()) +
          " " +
          _vm._s(_vm.pointLabel) +
          " with both scores available. Select a point or use the table to inspect it. "
      ),
      _vm.colorKey && (_vm.highlighted.length || _vm.selected)
        ? _c("span", [
            _vm._v(
              " Highlighted genes keep their support colors and have larger, outlined points; other genes fade. "
            ),
          ])
        : _vm._e(),
      _vm.selected && !_vm.points.some((row) => row.id === _vm.selected)
        ? _c("span", [
            _vm._v(
              "Selected gene " +
                _vm._s(_vm.selected) +
                " is outside the current filters or lacks one of these scores."
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }